<div [formGroup]="addressForm">
  <!-- ====================================================== -->
  <!-- REUSABLE TEMPLATE for the actual address form fields   -->
  <!-- ====================================================== -->
  <ng-template #addressFields>
    <!-- Street Address with Autocomplete -->
    <app-form-field label="Street Address" class="col-span-2 relative">
      <app-input
        #streetInput
        formControlName="street"
        placeholder="Start typing an address..."
        (inputFocus)="onStreetInputFocus()"
        (inputBlur)="onStreetInputBlur()"
        [autocomplete]="'off'"
      ></app-input>

      <!-- The predictions dropdown now works in both desktop and mobile-overlay contexts -->
      @if (isDropdownVisible()) {
      <app-address-predictions
        [predictions]="predictions()"
        [isLoading]="isLoading()"
        (predictionSelected)="selectPrediction($event)"
      ></app-address-predictions>
      }
    </app-form-field>

    <!-- Other Address Fields -->
    <app-form-field label="Apt, suite, etc. (Optional)" class="col-span-2">
      <app-input formControlName="street2" placeholder="Apt 4B"></app-input>
    </app-form-field>

    <app-form-field label="City">
      <app-input formControlName="city" placeholder="Anytown"></app-input>
    </app-form-field>

    <app-form-field label="State / Province">
      <app-select
        formControlName="state"
        [options]="stateAndProvinceOptions()"
        placeholder="State"
        [enableSearch]="true"
      ></app-select>
    </app-form-field>

    <!-- FIX: Use computed signals to make this field dynamic -->
    <app-form-field [label]="zipLabel()">
      <app-input
        formControlName="zip"
        [placeholder]="zipPlaceholder()"
        [mask]="zipMask()"
      ></app-input>
    </app-form-field>

    <app-form-field label="Country">
      <app-select
        formControlName="country"
        [options]="countryOptions"
        placeholder="Select country"
      ></app-select>
    </app-form-field>
  </ng-template>

  <!-- DESKTOP / TABLET VIEW -->
  @if (!isMobile()) {
  <div class="desktop-form-grid">
    <!-- Render the reusable form fields here -->
    <ng-container *ngTemplateOutlet="addressFields"></ng-container>
  </div>
  } @else {
  <!-- MOBILE VIEW -->
  <app-form-field label="Address">
    <app-address-display
      [line1]="formattedAddress().line1"
      [line2]="formattedAddress().line2"
      (click)="openMobileOverlay()"
      placeholder="Enter address"
    ></app-address-display>
  </app-form-field>

  <!-- The overlay logic remains the same -->
  @if (isOverlayVisible()) {
  <div class="mobile-overlay">
    <!-- Overlay Header with Cancel/Accept actions -->
    <div class="mobile-overlay-header">
      <button (click)="cancelChanges()" type="button" class="header-button">
        <lucide-icon name="x" [size]="24"></lucide-icon>
      </button>
      <h3 class="header-title">Edit Address</h3>
      <button
        (click)="acceptChanges()"
        type="button"
        class="header-button text-primary"
      >
        <lucide-icon name="check" [size]="24"></lucide-icon>
      </button>
    </div>

    <!-- Overlay Content -->
    <div class="mobile-overlay-content">
      <!-- Render the same reusable form fields inside the overlay -->
      <ng-container *ngTemplateOutlet="addressFields"></ng-container>
    </div>
  </div>
  } }
</div>
